import { Component, OnInit } from '@angular/core';
import { UserService } from "../../services/user.service";

@Component({
    selector: 'app-inst-configs',
    templateUrl: './inst-configs.component.html',
    styleUrls: ['./inst-configs.component.css'],
    standalone: false
})
export class InstConfigsComponent implements OnInit {
  environments: string[] = ['dev', 'qa', 'sandbox', 'uat', 'prod'];
  regions: string[] = ['asia', 'mena', 'europe', 'us', 'hk'];

  selectedEnvironment: string = '';
  selectedRegion: string = '';

  filterText: string = '';
  institutionConfig: any = null;
  institutionList: any[] = [];
  loading: boolean = false;
  copiedText: string = '';
  expandedRowIndex: number | null = null;

  constructor(private userService: UserService) { }

  ngOnInit(): void { }

  requiresRegion(env: string): boolean {
    return !['dev', 'qa', 'sandbox'].includes(env?.trim().toLowerCase());
  }

  getTableColSpan(): number {
    return 6;
  }

  searchInstitutions(): void {
    if (!this.selectedEnvironment) return;
    if (this.requiresRegion(this.selectedEnvironment) && !this.selectedRegion) return;

    this.loading = true;
    this.expandedRowIndex = null;
    this.userService.getInstitutionConfig(this.selectedEnvironment, this.selectedRegion, this.filterText)
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          this.institutionConfig = res;
          this.institutionList = (res.list || []).map((item: any) => this.normalizeInstitutionItem(item));
        },
        error: (err: any) => {
          this.loading = false;
          console.error('Backend error:', err);
        }
      });
  }

  onEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') this.searchInstitutions();
  }

  toggleRowExpand(index: number): void {
    this.expandedRowIndex = this.expandedRowIndex === index ? null : index;
  }

  isRowExpanded(index: number): boolean {
    return this.expandedRowIndex === index;
  }

  copyToClipboard(value: string, label: string = 'Value'): void {
    if (!value) return;
    navigator.clipboard.writeText(value).then(() => {
      this.copiedText = `${label} copied`;
      setTimeout(() => this.copiedText = '', 2000);
    }).catch(err => console.error('Failed to copy:', err));
  }

  getKeyPreview(text: string, compact: boolean = false): string {
    if (!text) return '—';
    const head = compact ? 10 : 16;
    const tail = compact ? 8 : 12;
    if (text.length <= head + tail + 1) return text;
    return `${text.slice(0, head)}…${text.slice(-tail)}`;
  }

  displayValue(value: string): string {
    return value?.trim() ? value : '—';
  }

  getNarration(item: any): string {
    return item?.narration?.trim() || '';
  }

  private normalizeInstitutionItem(item: any): any {
    const narration = item?.narration ?? item?.appNarration ?? '';

    return {
      ...item,
      narration: typeof narration === 'string' ? narration : String(narration ?? '')
    };
  }
}
